import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["body", "children", "e2e", "alignContent", "alignItems", "direction", "item", "justify", "container", "className", "spacing", "wrap", "sx"];
import * as React from 'react';
import { Grid as MUIGrid } from '@mui/material';

var Grid = function Grid(_ref) {
  var body = _ref.body,
      children = _ref.children,
      e2e = _ref.e2e,
      alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      direction = _ref.direction,
      item = _ref.item,
      justify = _ref.justify,
      container = _ref.container,
      className = _ref.className,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
      wrap = _ref.wrap,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(MUIGrid, _extends({}, e2e && {
    'data-e2e': e2e
  }, !!container && {
    spacing: spacing
  }, {
    alignContent: alignContent,
    alignItems: alignItems,
    direction: direction,
    item: item,
    justifyContent: justify,
    container: container,
    className: className,
    wrap: wrap,
    sx: sx
  }, props), body, children);
};

export default Grid;
//# sourceMappingURL=index.js.map